module.exports = __webpack_public_path__ + "static/img/in.7ff299bf.svg";